/**
 * Load state for the Copilot pane lifecycle.
 */ export const CopilotLoadState = {
    /** Copilot pane not initialized or disposed */ None: "none",
    /** Copilot pane is loading */ Loading: "loading",
    /** Copilot pane fully loaded and ready */ Loaded: "loaded",
    /** Copilot pane failed to load */ Failed: "failed"
};
/**
 * Reason a Copilot load failed, used to render the appropriate error message.
 * Only meaningful when the Copilot load state is Failed.
 */ export const CopilotFailureReason = {
    /** No failure */ None: "none",
    /** Failed before/at copilot render (Catalyst SDK init, eligibility, or render) */ LoadFailed: "loadFailed",
    /** Copilot rendered but the Planner agent did not load within the timeout */ AgentLoadTimeout: "agentLoadTimeout"
};
/**
 * Maximum time in ms to wait for the Planner agent to load before removing the overlay.
 */ export const CopilotAgentLoadTimeoutMs = 25000;
/** Default (and minimum) width in pixels of the Copilot sidecar panel */ export const CopilotSidecarPanelWidth = 400;
/** Maximum width in pixels the Copilot pane can be resized to */ export const CopilotSidecarPanelMaxWidth = 800;
/** Step size in pixels for keyboard-driven resizing of the Copilot pane (Arrow keys) */ export const CopilotPaneResizeStep = 16;
